import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import { Container } from 'web-ui-components/lib/global/layout';
import { PageHeading } from 'web-ui-components/lib/typography/headings';
import { StandoutTile, SubformRevealPanel } from 'web-ui-components/lib/layout/content';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { WebsiteLink } from 'web-ui-components/lib/actions/links';
import { StandardLabel } from 'web-ui-components/lib/typography/labels';
import {
	Table,
	TableBody,
	TableBodyData,
	TableHead,
	TableHeadData,
	TableRow,
} from 'web-ui-components/lib/molecules/tables';
import PageNavigation from '../../sharedComponents/PageNavigation/PageNavigation';
import withContent from '../../containers/withContent';
import ewContent from '../utils/content';
import { IBActions, declarationWebLink } from '../utils/constants';
import { getBrandId } from '../../states/envConfig/selectors';
import { isSMEUser, isApprovalJourney } from '../state/selectors';
import { resetEffectiveWarning, cancelPayment } from '../state/actions';
import { isPaymentInEditMode } from '../../states/modes/selectors';
import { ibRouteConstants } from '../../config';

const callChargesAndInfoData = [
	{
		key: '03 numbers',
		value:
			'Same as calls to 01 or 02 numbers and they are included in inclusive minutes and discount schemes in the same way.',
	},
	{ key: '084 numbers', value: 'Maximum of 7p per minute, plus your phone company’s access charge.' },
	{ key: '087 numbers', value: 'Maximum of 13p per minute, plus your phone company’s access charge.' },
	{ key: '0800 numbers', value: 'Free from UK landlines and personal mobile phones.' },
];

const mapState = (state) => ({
	brandId: getBrandId(state),
	isSMEUser: isSMEUser(state),
	isApprovalJourney: isApprovalJourney(state),
	isEdit: isPaymentInEditMode(state),
});

const mapDispatch = (dispatch) => ({
	resetEffectiveWarning: () => dispatch(resetEffectiveWarning()),
	cancelPayment: () => dispatch(cancelPayment()),
});
export class PaymentCancelled extends Component {
	constructor(props) {
		super(props);
		this.handleContinue = this.handleContinue.bind(this);
		this.state = {
			currentAccountsAndLoansPanelOpen: false,
			allOtherAccountsPanelOpen: false,
			callChargesPanelOpen: false,
		};
	}
	componentDidMount() {
		const { isSMEUser, onAction, isApprovalJourney, cancelPayment } = this.props;
		if (!isSMEUser) onAction(IBActions.CLEAR_MODAL_CONFIG);
		if (isApprovalJourney) {
			onAction(IBActions.ON_PAYMENT_GUIDANCE, { val: true });
			// REFACTOR - this action should happen outside this component
			cancelPayment();
		}
	}

	handleContinue(event) {
		event.preventDefault();
		const { resetEffectiveWarning, onAction, isEdit, handleRoute } = this.props;
		if (isEdit) handleRoute(ibRouteConstants.paymentStatus);
		else {
			onAction(IBActions.CANCEL_PAYMENT);
			resetEffectiveWarning();
		}
	}

	render() {
		const {
			content: {
				cancelledPayment: {
					pageHeading,
					pageSubheading,
					suspectFraudHeading,
					suspectFraudSubheading,
					callWillBeRecorded,
					section1,
					section2,
					section3,
					findOutMore,
					fraudAwarenessCentreText,
					telCurrent,
					telCurrentAbroad,
					telBus,
					telBusAbroad,
					availability,
				},
				doneText,
			},
			brandId,
		} = this.props;
		const { currentAccountsAndLoansPanelOpen, allOtherAccountsPanelOpen, callChargesPanelOpen } = this.state;
		return (
			<Container>
				<PageHeading data-test-id="payment-cancelled">{pageHeading}</PageHeading>
				<StandardBody>
					<p>{pageSubheading}</p>
				</StandardBody>
				<StandoutTile.Important>
					<StandardLabel>
						<h4>{suspectFraudHeading}</h4>
						<StandardBody>
							<span>{suspectFraudSubheading}</span>
						</StandardBody>
					</StandardLabel>
					<SubformRevealPanel
						isOpen={currentAccountsAndLoansPanelOpen}
						onClick={() =>
							this.setState((prevState) => ({
								currentAccountsAndLoansPanelOpen: !prevState.currentAccountsAndLoansPanelOpen,
							}))
						}
						titleText={section1}
					>
						<StandardBody>
							<span>{telCurrent}</span>
							<p>{telCurrentAbroad}</p>
							<p>{availability}</p>
						</StandardBody>
					</SubformRevealPanel>
					<SubformRevealPanel
						isOpen={allOtherAccountsPanelOpen}
						onClick={() =>
							this.setState((prevState) => ({ allOtherAccountsPanelOpen: !prevState.allOtherAccountsPanelOpen }))
						}
						titleText={section2}
					>
						<StandardBody>
							<span>{telBus}</span>
							<p>{telBusAbroad}</p>
							<p>{availability}</p>
						</StandardBody>
					</SubformRevealPanel>
					<SubformRevealPanel
						isOpen={callChargesPanelOpen}
						onClick={() => this.setState((prevState) => ({ callChargesPanelOpen: !prevState.callChargesPanelOpen }))}
						titleText={section3}
					>
						<Table isBranded>
							<TableHead>
								<TableRow>
									<TableHeadData>Number</TableHeadData>
									<TableHeadData>Cost</TableHeadData>
								</TableRow>
							</TableHead>
							<TableBody>
								{callChargesAndInfoData.map(({ key, value }) => (
									<TableRow>
										<TableBodyData title="Number">{key}</TableBodyData>
										<TableBodyData title="Cost">{value}</TableBodyData>
									</TableRow>
								))}
							</TableBody>
						</Table>
						<StandardBody>
							<span>{callWillBeRecorded}</span>
						</StandardBody>
					</SubformRevealPanel>
					<StandardBody>
						{findOutMore}
						<WebsiteLink willOpenNewWindow linkText={fraudAwarenessCentreText} url={declarationWebLink[brandId]} />
					</StandardBody>
				</StandoutTile.Important>
				<PageNavigation
					handleContinue={this.handleContinue}
					showContinue
					enableContinue
					continueButtonText={doneText}
				/>
			</Container>
		);
	}
}

PaymentCancelled.propTypes = {
	onAction: PropTypes.func.isRequired,
	content: PropTypes.shape({}),
	brandId: PropTypes.string.isRequired,
	isSMEUser: PropTypes.bool,
	resetEffectiveWarning: PropTypes.func,
	cancelPayment: PropTypes.func,
	isApprovalJourney: PropTypes.bool,
	isEdit: PropTypes.bool,
	handleRoute: PropTypes.func,
};

export default compose(connect(mapState, mapDispatch), withContent({ content: ewContent }))(PaymentCancelled);
